import { useContext } from "react";
import { AuthProvider } from "react-oidc-context";
import { ConfigContext } from "../../utils/ConfigContext";

const redirectUrl =
  window.location.protocol +
  "//" +
  window.location.host +
  window.location.pathname;

/*
 * Azure authentication related variables
 * Openid configuration can be found here: https://login.microsoftonline.com/462ad9ae-d7d9-4206-b874-71b1e079776f/.well-known/openid-configuration
 */
const wfpConfig = {
  authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}/`,
  client_id: process.env.REACT_APP_AZURE_CLIENT_ID,
  redirect_uri: redirectUrl,
  response_type: "code",
  response_mode: "fragment",
  scope: `openid profile`, // add other scopes here
  post_logout_redirect_uri: redirectUrl,
};

const ciamConfig = {
  authority: "https://ciam.auth.wfp.org/oauth2/oidcdiscovery",
  client_id: process.env.REACT_APP_AUTHENTICATION_CLIENT_ID,
  redirect_uri: "http://localhost:3000",
  redirect_homepage: "http://localhost:3000",
  response_type: "code",
  response_mode: "query",
  scope: `openid profile`, // add other scopes here
};

const AppAuthProvider = ({ children }) => {
  const { config } = useContext(ConfigContext);
  /**
   * Redirect to the original url, that is stored in the user object
   * @param user
   */
  const onSigninCallback = (user) => {
    if (user.state?.url) window.location.href = user.state.url;
  };

  const oidcConfig = config.auth === "wfp" ? wfpConfig : ciamConfig;

  return (
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      {children}
    </AuthProvider>
  );
};

export default AppAuthProvider;
